<template>
    <div>
        <Layout>
            <div id="scroll_edit" style="opacity: 0"></div>
            <div v-if="!isLoading" class="col-lg-12">
                <div class="position-absolute" style="top: -46px; right: 1rem; z-index: 10">
                    <div class="d-flex align-items-center justify-content-end">
                        <p class="mb-0 mr-2" style="font-size: 12px; color: #74788d">
                            {{ `${$t('managerForm.textDateTimeSync')}${formData?.published?.published_at ?? ''}` }}
                        </p>
                        <button
                            v-if="isShowButton"
                            :class="`btn btn-outline-${formData.is_a_changed ? 'danger' : 'warning'} btn-only-icon mr-2`"
                            style="padding-block: 7px"
                            :disabled="
                                [STATUS_FORM_LIST.CREATED, STATUS_FORM_LIST.UNPUBLISHED].includes(formData?.status) || formData.is_first_create
                            "
                            @click="onHandleTranformPage"
                        >
                            <i class="mdi mdi-web"></i>
                        </button>
                        <button v-if="isShowButton" class="btn btn-common btn-warning" @click="onHandleSyncForm">
                            {{ $t('managerForm.syncFormPublic') }}
                        </button>
                    </div>
                    <div v-if="formData.is_a_changed" class="pt-3 text-right text-note">
                        {{ $t('managerForm.noteUpdateFormWeb') }}
                    </div>
                </div>
                <div class="card mb-0">
                    <div class="card-body" style="min-height: 100vh">
                        <b-tabs
                            :value="modelTab"
                            vertical
                            justified
                            nav-class="nav-tabs-custom cus-document"
                            active-nav-item-class="font-weight-bold"
                            content-class="p-3 text-muted"
                            @input="onInputTabChanged"
                            @activate-tab="onTabChanged"
                        >
                            <b-tab v-for="(tab, index) in TABS" :key="index" class="border-0" :disabled="tab.disabled" @click="onHandleCickTab(tab)">
                                <template v-slot:title>
                                    <span class="">{{ tab.name }}</span>
                                </template>
                                <div>
                                    <SettingBasic
                                        v-if="tab.id === 1"
                                        :dataForm.sync="formData"
                                        :configForm="configFormBasic"
                                        :templatePage="temporarilyList"
                                        :listPage="PAGE_TYPE_FIXED"
                                        :configValidFormLottery="formLotteryConfig"
                                        @handleOpenSelectTemplate="openSelectTemplate"
                                    />
                                    <SettingDesign ref="settingDesign" v-else-if="tab.id === 2" :dataForm.sync="formData" />
                                    <SettingPage
                                        v-else-if="tab.id === 3"
                                        ref="settingPage"
                                        :dataForm.sync="formData"
                                        :listPage="PAGE_TYPE_FIXED"
                                        :configForm="configFormPage"
                                    />
                                    <PageSettingMailI
                                        v-else-if="tab.id === 4"
                                        ref="PageSettingMailI"
                                        :dataMailTemplate.sync="formData.registration_email_template"
                                        :optionTemplate="templateSendList"
                                        :optionSenderMail="senderFormList"
                                        @openTemplate="onGetListAllTemplateMail"
                                    />
                                    <SettingSerialCode
                                        v-else-if="tab.id === 6"
                                        ref="SettingSerialCode"
                                        :dataForm.sync="formData.setting_serial_code"
                                        :inforForm="formData"
                                        :tableImportConfig="CONFIG_TABLE_IMPORT"
                                        @callGetListSerial="onHandleGetListSerial"
                                    />
                                    <PrizeSerialCode
                                        v-else-if="tab.id === 7"
                                        ref="PrizeSerialCode"
                                        :dataPrizes.sync="formData.serial_code_prizes"
                                        :inforLottery="formData.setting_lottery"
                                        :inforForm="formData"
                                        @onHandleSettingCalendar="eventSettingCalendar"
                                    />
                                    <SettingCalendar
                                        ref="settingCalendar"
                                        v-else-if="tab.id === 8"
                                        :dataPrizes.sync="formData.serial_code_prizes"
                                        :infoPrizeCalendar="prizeCalendarInfo"
                                        :indexPrizeCalendar="prizeCalendarIndex"
                                        :inforLottery="formData.setting_lottery"
                                        :formCalendar.sync="formCalendar"
                                        :configCalendar.sync="calendarConfig"
                                        :loading.sync="isCalendarDataLoading"
                                        :isActive="modelTab === index"
                                        @selectPrize="onCalendarPrizeSync"
                                    />
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                    <ModalListPreview
                        :formData="{ ...formData, forms: formData.campaign_forms, landing_pages: formData.campaign_lps }"
                        :config.sync="configModalListPrv"
                    />
                </div>
                <Footer>
                    <div v-if="!buttonEvent.eventEditPrizeSerialCode" :style="`display: grid; grid-template-columns: 1fr 1fr 1fr`">
                        <div class="d-flex align-items-center" style="gap: 0.7rem">
                            <button @click="handleCancel" class="btn btn-common-footer">
                                <i class="ri-list-check"></i>{{ $t('btn.backListForm') }}
                            </button>
                            <button
                                v-if="!buttonEvent.eventEditBlock && !buttonEvent.eventEditBlockStep2 && !buttonEvent.eventEditButton"
                                @click="handleCancel('detail')"
                                class="btn btn-common btn-info"
                            >
                                <i class="ri-arrow-left-line"></i>{{ $t('managerForm.settingPage.returnToPageDetail') }}
                            </button>
                            <button
                                v-if="buttonEvent.eventEditPage"
                                @click="onHandleCickTab({ name: TAB_NAME.page })"
                                class="btn btn-common btn-info"
                            >
                                <i class="ri-arrow-left-line"></i>{{ $t('managerForm.settingPage.returnToPageList') }}
                            </button>
                        </div>
                        <div :class="`text-center ${formData?.published?.published_at ? 'mr-2' : ''} `">
                            <div class="d-flex align-items-center justify-content-center" style="gap: 0.5rem">
                                <button
                                    v-if="!isPageType(ID_PAGE_TYPE.C)"
                                    type="button"
                                    class="btn btn-common-footer"
                                    @click="() => (configModalListPrv.model = true)"
                                >
                                    <i class="ri-link-m"></i>{{ $t('pageCampaign.listLinkLPAndForm') }}
                                </button>
                                <template v-if="!buttonEvent.eventEditBlock && !buttonEvent.eventEditBlockStep2">
                                    <template v-if="!isPageType(ID_PAGE_TYPE.C)">
                                        <button
                                            v-if="checkPermission('form.analytics')"
                                            type="button"
                                            :class="`btn btn-common-footer ${[STATUS_FORM_LIST.RESERVING].includes(formData.status) ? 'disabled_cursor' : ''}`"
                                            :disabled="[STATUS_FORM_LIST.RESERVING].includes(formData.status)"
                                            @click="handleToGo('/manager-form/analytics', formData)"
                                        >
                                            <i class="ri-line-chart-line"></i>{{ $t('landingPage.settingBasic.analytics') }}
                                        </button>
                                        <button
                                            href="javascript:void(0)"
                                            :class="`btn btn-common-footer ${[STATUS_FORM_LIST.RESERVING].includes(formData.status) ? 'disabled_cursor' : ''}`"
                                            :disabled="[STATUS_FORM_LIST.RESERVING].includes(formData.status)"
                                            @click="handleToGo('/manager-form/advanced', formData)"
                                        >
                                            <i class="ri-mail-line"></i>{{ $t('managerForm.settingAdvanced.btnAdvanced') }}
                                        </button>
                                    </template>
                                    <template v-if="![STATUS_FORM_LIST.RESERVING].includes(formData.status)">
                                        <div class="d-flex justify-content-between">
                                            <button
                                                v-if="[STATUS_FORM_LIST.PUBLISHING].includes(formData.status)"
                                                href="javascript:void(0)"
                                                class="btn btn-only-icon btn-outline-primary mr-2"
                                                style="min-width: 36px"
                                                @click="handleOpenModalSettingDate()"
                                            >
                                                <i class="ri-calendar-line mr-0"></i>
                                            </button>
                                            <button
                                                v-if="![STATUS_FORM_LIST.PUBLISHING].includes(formData.status) && !formData.is_first_create"
                                                href="javascript:void(0)"
                                                :class="`btn btn-common btn-warning ${![STATUS_FORM_LIST.CREATED, STATUS_FORM_LIST.UNPUBLISHED].includes(formData.status) ? 'action__record' : ''}`"
                                                @click="handleOpenModalSettingDate()"
                                            >
                                                <i class="ri-global-line"></i>{{ $t('managerForm.list.settingDatePublish') }}
                                            </button>
                                        </div>
                                    </template>
                                    <template v-if="![STATUS_FORM_LIST.CREATED, STATUS_FORM_LIST.UNPUBLISHED].includes(formData.status)">
                                        <button
                                            v-if="[STATUS_FORM_LIST.RESERVING].includes(formData.status)"
                                            href="javascript:void(0)"
                                            class="btn btn-common btn-secondary mr-2"
                                            @click="handleCancelNowBooking(formData)"
                                        >
                                            {{ $t('managerForm.list.cancelDateNowBooking') }}
                                        </button>
                                        <button
                                            v-if="[STATUS_FORM_LIST.PUBLISHING].includes(formData.status)"
                                            href="javascript:void(0)"
                                            class="btn btn-common btn-danger"
                                            @click="handleCancelPublish()"
                                        >
                                            <i class="ri-indeterminate-circle-line"></i>{{ $t('managerForm.list.cancelPublishForm') }}
                                        </button>
                                    </template>
                                </template>
                                <template v-if="buttonEvent.eventEditBlock">
                                    <button type="button" class="btn btn-common btn-primary" style="min-width: 74px" @click="callChildCancelBlock">
                                        <i class="ri-arrow-left-line"></i>{{ $t('managerForm.settingPage.buttonType.backStep') }}
                                    </button>
                                    <button type="button" class="btn btn-common btn-info" @click="callChildNextStep1">
                                        {{
                                            isSaveSettingBlock
                                                ? $t('managerForm.settingPage.buttonType.saveSettingBlock')
                                                : $t('managerForm.settingPage.buttonType.nextStep')
                                        }}
                                    </button>
                                </template>
                                <template v-if="buttonEvent.eventEditBlockStep2">
                                    <button type="button" class="btn btn-common btn-primary" style="min-width: 74px" @click="callChildBackStep1">
                                        <i class="ri-arrow-left-line"></i>{{ $t('managerForm.settingPage.buttonType.backStep') }}
                                    </button>
                                    <button type="button" class="btn btn-common btn-info" @click="callChildSaveStep2">
                                        {{ $t('managerForm.settingPage.buttonType.saveSettingBlock') }}
                                    </button>
                                </template>
                            </div>
                        </div>
                        <div class="text-right">
                            <div class="d-flex align-items-center justify-content-end" style="gap: 0.5rem">
                                <button v-if="isShowButton" type="button" @click="handleOpenSaveTemp" class="btn btn-common-footer">
                                    <i class="ri-download-line"></i>{{ $t('managerForm.saveTemporarily') }}
                                </button>
                                <button :class="`btn btn-common-footer`" @click="onHandleOpenPreview">
                                    <i class="ri-eye-line"></i>{{ $t('btn.preview') }}
                                </button>
                                <template v-if="!buttonEvent.eventEditBlock && !buttonEvent.eventEditBlockStep2 && !buttonEvent.eventEditButton">
                                    <button
                                        v-if="checkPermission('form.register')"
                                        type="submit"
                                        @click="onHandleCopy"
                                        class="btn btn-common-footer"
                                        :disabled="[STATUS_FORM_LIST.RESERVING].includes(formData.status)"
                                    >
                                        <i class="ri-file-copy-2-line"></i>{{ $t('btn.copy') }}
                                    </button>
                                    <button type="submit" @click="handleSubmit" class="btn btn-common btn-success" style="min-width: 100px">
                                        {{ $t('btn.save') }}
                                    </button>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div v-else :style="`display: grid; grid-template-columns: 1fr`">
                        <div class="text-center">
                            <template v-if="!buttonEvent.eventSettingBlockLotterySerial && !buttonEvent.eventSettingBlockRejectionSerial">
                                <button type="button" class="btn btn-common-cancel mr-3" @click="onCancelSerialPrize">
                                    {{ $t('btn.cancel') }}
                                </button>
                                <button type="button" class="btn btn-common btn-success" @click="onSaveSerialPrize">
                                    {{ $t('btn.save') }}
                                </button>
                            </template>
                            <template v-if="buttonEvent.eventSettingBlockLotterySerial || buttonEvent.eventSettingBlockRejectionSerial">
                                <button type="button" class="btn btn-common btn-primary mr-3" style="min-width: 74px" @click="onBackStepSerialBlock">
                                    <i class="ri-arrow-left-line"></i>{{ $t('managerForm.settingPage.buttonType.backStep') }}
                                </button>
                                <button type="button" class="btn btn-common btn-info" @click="onNextStepSerialBlock">
                                    {{ $t('managerForm.settingPage.buttonType.saveSettingBlock') }}
                                </button>
                            </template>
                        </div>
                    </div>
                </Footer>
                <ModalTemporarily :configModal="configModalTemporarily" @save="handleSaveTemporarily" />
            </div>
            <div class="d-flex justify-content-center" v-else>
                <LoadingIcon />
            </div>
            <div
                v-if="isCalendarDataLoading"
                style="
                    position: fixed;
                    inset: 0;
                    background: rgba(255, 255, 255, 0.7);
                    z-index: 9999;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                "
            >
                <LoadingIcon />
            </div>
            <ModalPreviewForm v-if="configModalPrvForm.model" :formData="formData" :prvFormConfig="configModalPrvForm" />
            <ModalSettingDatePublish
                v-if="this.configModalSettingDatePublish.model"
                :currentRowSettingDate="formData"
                :configModalSettingDatePublish="configModalSettingDatePublish"
                :screen="`edit`"
                @update-get-list="getDetail()"
            />

            <ModalCopyForm :dataForm="formData" :mailInfor="inforMailForm" :masterCampaign="listDataMasterCampaign" :config="configModalCopyForm" />
        </Layout>
    </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import Footer from '@/components/Footer/main.vue';
import SettingBasic from '../components/setting-basic/main.vue';
import SettingDesign from '../components/setting-design/main.vue';
import SettingPage from '../components/setting-page/main.vue';
import SettingSerialCode from '../components/setting-serial-code/main.vue';
import PrizeSerialCode from '../components/prize-serial-code/main.vue';
import SettingCalendar from '../components/setting-calendar/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';
import ModalTemporarily from '../components/modal-temporarily/main.vue';
import ModalListPreview from '@/views/pages/campaign/view/components/ModalListPreview/main.vue';
import PageSettingMailI from '@/views/pages/phase2/manager-form/components/setting-page/components/page-setting-mail-i.vue';
import ModalSettingDatePublish from '../components/modal-setting-date-publish/main.vue';
import ModalCopyForm from '@/views/pages/phase2/manager-form/view/components/modal-copy/main.vue';
import ModalPreviewForm from '@/views/pages/phase2/manager-form/components/modal-preview-form/main.vue';

import { checkPermission, onHandleShowConfirm, getInfoUserLocalStorage, onScrollToFieldError } from '@/utils/handlers';
import { STATUS_MAIL } from '@/views/pages/phase2/manager-form/email/constants.js';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { mapState } from 'vuex';
import { TABS, TAB_NAME, initForm, PAGE_TYPE_FIXED, STATUS_FORM_LIST, configs, ID_PAGE_TYPE, onHandleTabForm, initInputCalendar } from '../constants';
import { configFormBasic } from '../components/setting-basic/constants';
import { configFormPage } from '../components/setting-page/constants';
import { validateAllField } from '@/utils/validate';
import {
    handleDataBeforeSendServer,
    handleDataResponse,
    handleAlertValidateTabs,
    validateTableWidth,
    handleGetListSerial,
    onHandleGetListTemporarily,
    onHandleTemporarily
} from '../handlers';
import { masterMethods, managerFormMethods } from '@/state/helpers';
import { showMessage } from '@/utils/messages';
import { configs as configSettingDesign } from '../components/setting-design/constants';
import { configModalTemporarily } from '../components/modal-temporarily/constants';
import { TYPE_TEMPLATE } from '@/views/pages/phase2/manager-form/components/setting-page/components/constants-mail';
import { handleValidSettingLottery, configFormLottery } from '@/views/pages/phase2/manager-form/components/setting-lottery/constants';
import {
    initFormCalendar,
    configFormCalendar,
    handleValidCalendar,
    createIdEventRangeDate
} from '@/views/pages/phase2/manager-form/components/setting-calendar/constants';
import { configModalCopyForm } from '@/views/pages/phase2/manager-form/view/components/modal-copy/constants';
import { isRolePartner } from '@/views/pages/require/handlers.js';
import { CONFIG_TABLE_IMPORT } from '@/views/pages/phase2/manager-form/components/setting-serial-code/constants';

export default {
    name: 'ManagerFormEdit',
    page: {
        title: 'キャンペーン一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        Footer,
        SettingBasic,
        SettingDesign,
        SettingPage,
        SettingSerialCode,
        PrizeSerialCode,
        SettingCalendar,
        LoadingIcon,
        ModalTemporarily,
        ModalListPreview,
        PageSettingMailI,
        ModalSettingDatePublish,
        ModalCopyForm,
        ModalPreviewForm
    },
    beforeRouteEnter(to, from, next) {
        if (!checkPermission('form.edit')) {
            next({ name: 'errorPage' });
        }
        next();
    },
    data() {
        return {
            CONFIG_TABLE_IMPORT,
            ALL_BLOCK_TYPE,
            TABS: TABS(),
            TAB_NAME,
            configSettingDesign: configSettingDesign,
            formData: initForm(),
            configFormBasic: configFormBasic(),
            configFormPage: configFormPage(),
            formLotteryConfig: configFormLottery(),
            formCalendar: initFormCalendar(),
            calendarConfig: configFormCalendar(),
            PAGE_TYPE_FIXED: PAGE_TYPE_FIXED,
            STATUS_FORM_LIST: STATUS_FORM_LIST,
            configModalTemporarily,
            configModalListPrv: configs.configModalListPrv,
            configModalSettingDatePublish: configs.configModalSettingDatePublish,
            configModalCopyForm,
            isLoading: false,
            modelTab: 0,
            configModalPrvForm: configs.configModalPrvForm,
            temporarilyList: [],
            senderFormList: [],
            templateSendList: [],
            cloneTemplateList: [],
            STATUS_MAIL,
            ID_PAGE_TYPE,
            prizeCalendarInfo: null,
            prizeCalendarIndex: 0,
            arrIdPrizeDaily: [],
            inforMailForm: null,
            listDataMasterCampaign: [],
            isCalendarDataLoading: false
        };
    },

    computed: {
        ...mapState({
            ...mapState('managerForm', ['buttonEvent'])
        }),

        isShowButton() {
            const { eventEditBlock, eventEditBlockStep2 } = this.buttonEvent;
            return !eventEditBlock && !eventEditBlockStep2;
        },

        isSaveSettingBlock() {
            const currentBlockType = this.$refs.settingPage[0]?.$refs.modalEditPage?.configSettingBlock?.type;
            return [ALL_BLOCK_TYPE.BLOCK_DISPLAY_1, ALL_BLOCK_TYPE.BLOCK_DISPLAY_2].includes(currentBlockType);
        },

        formPublicUrl() {
            let domain = this.formData?.custom_domain?.domain || process.env.VUE_APP_DOMAIN_FORM;
            if (this.formData?.is_a_changed && this.formData?.published_domain) {
                domain = this.formData.published_domain;
            }
            return `https://${domain}/form/${this.formData?.url_public}`;
        },

        isPageType() {
            return (pageType) => this.formData?.page_type?.id === pageType;
        }
    },
    watch: {
        modelTab() {
            this.$nextTick(() => {
                onScrollToFieldError();
            });
        }
    },
    methods: {
        checkPermission,
        ...masterMethods,
        ...managerFormMethods,
        async onTabChanged(newTabIndex, prevTabIndex, bvEvent) {
            if (newTabIndex === this.modelTab) return;
            let { eventEditBlock, eventEditBlockStep2, eventEditButton, eventEditPrizeSerialCode } = this.buttonEvent;
            const hasUnsavedChanges = eventEditBlock || eventEditBlockStep2 || eventEditButton || eventEditPrizeSerialCode;
            if (hasUnsavedChanges) {
                bvEvent.preventDefault();
                const confirmExitSettingForm = await onHandleShowConfirm({
                    title: '',
                    text: 'ページ設定内容がまだ保存されない可能性がありますが、移動してもよろしいですか。'
                });
                if (confirmExitSettingForm) {
                    if (eventEditPrizeSerialCode) {
                        this.$refs.PrizeSerialCode[0].onHandleCancel();
                        this.$refs.PrizeSerialCode[0].handleCancelPrizeBlock();
                    } else {
                        if (this.$refs?.settingPage[0]) this.$refs.settingPage[0].onHandleCloseSettingBlock();
                        this.callChildBackStep1();
                        this.callChildCancelBlock();
                        this.callChildCancelSettingPage('reset');
                        this.updateButtonEvent({ eventEditPage: false, eventEditBlock: false, eventEditBlockStep2: false, eventEditButton: false });
                        localStorage.removeItem('typePageWl');
                    }
                    this.onHandleCalendarMounted();
                    this.modelTab = newTabIndex;
                } else {
                    this.modelTab = prevTabIndex;
                }
            } else {
                this.modelTab = newTabIndex;
                if (this.$refs?.settingPage[0]) this.$refs.settingPage[0].onHandleCloseSettingBlock();
                this.updateButtonEvent({ eventEditPage: false });
            }
        },
        async handleCancelPublish() {
            const confirm = await onHandleShowConfirm({
                text: `フォーム「(${this.formData.id}) ${this.formData.name}」の公開を停止します。本当によろしいですか。`
            });
            if (confirm) {
                try {
                    const dataRes = await this.stopPublishNow({ id: this.formData.id });
                    if (dataRes?.code !== 200) {
                        showMessage(dataRes.code, this.$bvToast, this.$t('system.error'));
                        return;
                    }
                    this.getDetail();
                } catch (error) {
                    console.log('error', error);
                }
            }
        },
        async handleCancelNowBooking(row) {
            const confirm = await onHandleShowConfirm({ text: `フォーム「(${row.id}) ${row.name}」の公開予約を解除します。本当によろしいですか。` });
            if (confirm) {
                try {
                    const dataRes = await this.stopPublishNow({ id: row.id });
                    if (dataRes?.code !== 200) {
                        showMessage(dataRes.code, this.$bvToast, this.$t('system.error'));
                        return;
                    }
                    this.getDetail();
                } catch (error) {
                    console.log('error', error);
                }
            }
        },
        handleOpenModalSettingDate() {
            this.configModalSettingDatePublish.title = this.$t('managerForm.list.settingDatePublish');
            this.configModalSettingDatePublish.model = true;
        },

        onHandleCickTab(tab) {
            localStorage.setItem('currentTabForm', tab.name);
            if (tab.name === TAB_NAME.page) {
                const getPageEdit = JSON.parse(localStorage.getItem('typePageWl'));
                if (getPageEdit) {
                    localStorage.setItem('typePageWl', JSON.stringify({ ...getPageEdit, id: this.$route.query.id, tab_name: TAB_NAME.page }));
                } else {
                    localStorage.setItem('typePageWl', JSON.stringify({ id: this.$route.query.id, tab_name: TAB_NAME.page }));
                }
                if (this.$refs?.settingPage[0]) this.$refs.settingPage[0].onHandleCloseSettingBlock();
                this.callChildBackStep1();
                this.callChildCancelBlock();
                this.callChildCancelSettingPage('reset');
                this.updateButtonEvent({ eventEditPage: false, eventEditBlock: false, eventEditBlockStep2: false, eventEditButton: false });
            }
            if (tab.name === TAB_NAME.page_setting_calendar_lottery) {
                this.$refs?.settingCalendar[0]?.$refs?.CalendarFull?.getApi().removeAllEvents();
                this.onHandleCalendarMounted();
                this.$refs?.settingCalendar[0]?.onResetData();
            }
            if (tab.name === TAB_NAME.page_setting_serial_code) {
                this.$refs?.SettingSerialCode[0]?.onResetData();
                this.$refs?.SettingSerialCode[0]?.onHandleCheckStatusSerial();
            }
        },

        onInputTabChanged(tabIndex) {
            if (tabIndex === 1) {
                this.$nextTick(() => {
                    this.$refs.settingDesign[0].refreshCodeMirror();
                });
            }
        },

        handleCancel(type = 'list') {
            if (type === 'detail') {
                this.$router.push({
                    path: '/manager-form/view',
                    query: { id: this.$route.query.id, tab: this.modelTab }
                });
                return;
            }
            this.$router.push({
                path: '/manager-form/list'
            });
        },

        handleToGo(url, row) {
            if ([STATUS_FORM_LIST.RESERVING].includes(row.status)) return;
            this.$router.push({ path: url, query: { id: row.id } });
        },

        onHandleTranformPage() {
            window.open(this.formPublicUrl, '_blank');
        },

        onHandleOpenPreview() {
            if ([ID_PAGE_TYPE.I, ID_PAGE_TYPE.B].includes(this.formData?.page_type?.id)) {
                this.configModalPrvForm.model = true;
            } else {
                window.open(`/manager-form/preview?id=${this.$route.query.id}&type=${this.formData?.page_type?.alias}`, '_blank');
            }
        },

        async handleSubmit() {
            let checkPageRef = this.callChildSaveSettingPage();
            const checkTableWidth = validateTableWidth(
                this.configSettingDesign.configFieldTableWidth,
                this.configSettingDesign.configFieldAnswerWidth,
                this.configSettingDesign.configFieldQuestionWidth
            );
            let checkValidateTabs = handleAlertValidateTabs(
                {
                    checkFormBasic: validateAllField(this.configFormBasic),
                    checkStarPublichWithEndPublic: true, //validateEndDate(this.configFormBasic['configFieldPublicationStartDateTime'],this.configFormBasic['configFieldPublicationEndDateTime'])
                    checkSettingDesign: validateAllField(this.configSettingDesign) && checkTableWidth,
                    checkFormPage: true, // validateAllField(this.configFormPage)
                    checkTabSettingMail:
                        this.$refs?.PageSettingMailI && this.$refs?.PageSettingMailI[0] ? this.$refs.PageSettingMailI[0].onHandleSubmit() : true,
                    checkTabSettingLottery:
                        this.formData?.page_type?.id === ID_PAGE_TYPE.B
                            ? handleValidSettingLottery(this.formData.setting_lottery, this.formLotteryConfig)
                            : true,
                    checkTabSettingCalendar:
                        this.formData?.page_type?.id === ID_PAGE_TYPE.B ? handleValidCalendar(this.formCalendar, this.calendarConfig) : true
                },
                this.$bvToast,
                this.modelTab,
                this.TABS
            );
            validateTableWidth(
                this.configSettingDesign.configFieldTableWidth,
                this.configSettingDesign.configFieldAnswerWidth,
                this.configSettingDesign.configFieldQuestionWidth
            );
            if (!checkValidateTabs.check || !checkTableWidth || !checkPageRef) {
                this.$nextTick(() => {
                    onScrollToFieldError();
                });
                return;
            }
            let payload = handleDataBeforeSendServer(this.formData);
            this.isCalendarDataLoading = true;
            try {
                const data = await this.updateManagerForm(payload);
                if (data?.code !== 200) {
                    showMessage(data?.code, this.$bvToast, this.$t(data?.message));
                    return;
                }
                showMessage(data?.code, this.$bvToast, '本番フォームサイトに反映させるには黄色い本番フォームサイト更新のボタンを押してください。');
                showMessage(data?.code, this.$bvToast, 'フォームが更新されました。');
                await this.getDetail(true);
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isCalendarDataLoading = false;
            }
        },

        async getDetail(isRefresh = false) {
            if (!this.$route?.query?.id) return;
            this.arrIdPrizeDaily = [];
            if (!isRefresh) {
                this.isLoading = true;
            }
            try {
                const response = await this.getDetailManagerForm(this.$route.query.id);
                if ([STATUS_FORM_LIST.RESERVING].includes(response?.status)) {
                    this.handleCancel();
                    return;
                }
                handleDataResponse(this.formData, response);
                this.TABS = onHandleTabForm(this.formData?.page_type?.id);
                this.formData.registration_email_template = {
                    ...this.formData.registration_email_template,
                    invite: {
                        ...this.formData.registration_email_template.invite,
                        template:
                            this.cloneTemplateList.find((item) => item.id === response.registration_email_template?.invite?.template?.id) || null,
                        email_sender: response.registration_email_template?.invite?.email_sender?.id
                            ? this.senderFormList.find((item) => item.id === response.registration_email_template.invite.email_sender.id)
                            : this.senderFormList[0]
                    }
                };
                await this.onHandleGetListSerial();
                await Promise.all(
                    this.formData.serial_code_prizes.map(async (prize) => {
                        try {
                            const data = await this.onGetDailyLimitsPrize(prize);
                            prize.prize_date_event.daily_limits = (data || []).map(initInputCalendar);
                        } catch {
                            prize.prize_date_event.daily_limits = [];
                        }
                    })
                );
                if (isRefresh) {
                    const selectedPrize =
                        this.formData.serial_code_prizes.find((p) => p.extension?.is_selected) || this.formData.serial_code_prizes[0];
                    if (selectedPrize) {
                        this.prizeCalendarInfo = {
                            ...selectedPrize,
                            prize_date_event: {
                                ...selectedPrize.prize_date_event
                            }
                        };
                        this.prizeCalendarIndex++;
                    }
                }
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
            this.onHandleCalendarMounted();
        },

        callChildSaveSettingPage() {
            let checkValid = true;
            checkValid = this.$refs.settingPage[0].$refs.modalEditPage.handleSave();
            return checkValid;
        },

        callChildCancelSettingPage(type) {
            localStorage.removeItem('activePage');
            if (!this.$refs.settingPage[0]?.$refs?.modalEditPage) return;
            if (type === 'reset') {
                this.$refs.settingPage[0].$refs.modalEditPage.onRestWork();
            } else {
                this.$refs.settingPage[0].$refs.modalEditPage.handleClose();
                this.$refs.settingPage[0].$refs.modalEditPage.onRestWork();
            }
        },

        callChildCancelBlock() {
            if (!this.$refs.settingPage[0]?.$refs?.modalEditPage?.$refs?.settingBlockForm) return;
            this.$refs.settingPage[0].$refs.modalEditPage.$refs.settingBlockForm.handleCancelBlock();
            this.$refs.settingPage[0].$refs.modalEditPage.onHiddenBtnWork();
        },

        callChildNextStep1() {
            this.$refs.settingPage[0].$refs.modalEditPage.$refs.settingBlockForm.handleSaveStep1();
        },

        callChildBackStep1() {
            if (!this.$refs.settingPage[0]?.$refs?.modalEditPage?.$refs?.settingBlockForm?.$refs?.additionalSettings) return;
            this.$refs.settingPage[0].$refs.modalEditPage.$refs.settingBlockForm.$refs.additionalSettings.handleBackStep1();
        },

        callChildSaveStep2() {
            this.$refs.settingPage[0].$refs.modalEditPage.$refs.settingBlockForm.$refs.additionalSettings.handleSaveSettingBlock();
        },
        handleOpenSaveTemp() {
            this.configModalTemporarily.model = true;
        },

        openSelectTemplate() {
            onHandleGetListTemporarily(this);
        },

        async handleSaveTemporarily(evt) {
            onHandleTemporarily(evt, this);
        },

        onHandleRemoveId(pageForm) {
            if (pageForm) {
                delete pageForm.page_inputs?.id;
                delete pageForm.page_confirms?.id;
                delete pageForm.page_completes?.id;
                if (pageForm.page_inputs?.blocks) {
                    pageForm.page_inputs.blocks = pageForm.page_inputs.blocks.map((blockItem) => {
                        if (blockItem.option_values) {
                            blockItem.option_values = blockItem.option_values.map((item) => {
                                delete item.id;
                                delete item.form_block_id;
                                return item;
                            });
                        }
                        return blockItem;
                    });
                }
                if (pageForm.page_completes?.blocks) {
                    pageForm.page_completes.blocks = pageForm.page_completes.blocks.map((blockItem) => {
                        return blockItem;
                    });
                }
            }
            return pageForm;
        },

        async onHandleSyncForm() {
            const confirmSync = await onHandleShowConfirm({ title: '', text: '最新の更新内容を本番フォームサイトに反映します。よろしいですか。' });
            if (!confirmSync) return;
            try {
                let payload = {
                    id: this.formData.id
                };
                await this.syncFormPublish(payload);
                const response = await this.getDetailManagerForm(this.$route.query.id);
                this.formData.published = response?.published;
                this.formData.is_a_changed = response?.is_a_changed === 1 ? true : false;
                this.formData.published_domain = response?.published_domain ?? null;
            } catch (error) {
                console.log('error', error);
                showMessage(error.code, this.$bvToast, error.message);
            }
        },

        onResetLocalStorage() {
            localStorage.removeItem('currentTabForm');
            localStorage.removeItem('typePageWl');
            localStorage.removeItem('activePage');
            this.updateButtonEvent({ eventEditPage: false, eventEditBlock: false, eventEditBlockStep2: false, eventEditButton: false });
        },

        returnStatusMailLabel(status) {
            return STATUS_MAIL.find((item) => item.value === status)?.label;
        },

        async onGetListAllEmailFrom() {
            this.isLoading = true;
            try {
                let dataRes = await this.getListAllEmailFrom();
                this.senderFormList = dataRes?.map((item) => ({
                    ...item,
                    label_mail: `${item.email_address} - ${item.title} - 認証ステータス: ${this.returnStatusMailLabel(item.status_domain)}`
                }));
            } catch (error) {
                console.log('error', error);
            }
        },

        async onGetListAllTemplateMail(evtType) {
            this.templateSendList = [];
            try {
                let dataRes = await this.getListAllTemplateMail();
                this.cloneTemplateList = dataRes;
                if (evtType === 'typeInvite') {
                    this.templateSendList = dataRes.filter((item) => item.template_type === TYPE_TEMPLATE.INVITE);
                } else {
                    this.templateSendList = dataRes;
                }
            } catch (error) {
                console.log('error', error);
            }
        },

        async onGetDailyLimitsPrize(evt) {
            if (!evt?.id || this.arrIdPrizeDaily.includes(evt.id)) return [];
            let payload = {
                form_id: this.formData.id,
                prize_id: evt.id
            };
            try {
                const dataRes = await this.getDailyLimitsPrizeForm(payload);
                if (dataRes?.code !== 200) {
                    showMessage(dataRes.code, this.$bvToast, dataRes.message);
                    return;
                }
                this.arrIdPrizeDaily.push(evt.id);
                return dataRes.data;
            } catch (error) {
                showMessage(error.code, this.$bvToast, error.message);
            }
        },

        async eventSettingCalendar(evt) {
            this.isCalendarDataLoading = true;
            let dataDailyEvent = await this.onGetDailyLimitsPrize(evt);
            this.isCalendarDataLoading = false;
            dataDailyEvent = dataDailyEvent?.map((e) => initInputCalendar(e)) || [];
            let eventDailyLocal = [];
            if (evt.prize_date_event.daily_limits?.length > 0) {
                eventDailyLocal = evt.prize_date_event.daily_limits.map((e) => {
                    e.id = createIdEventRangeDate({
                        startStr: e.startStr,
                        endStr: e.endStr
                    });
                    return e;
                });
            }

            this.formData.serial_code_prizes = this.formData.serial_code_prizes.map((p) => {
                const isSelected = p.make_id === evt.make_id || (p.id && p.id === evt.id);
                return {
                    ...p,
                    extension: {
                        ...p.extension,
                        is_selected: isSelected
                    }
                };
            });

            this.prizeCalendarInfo = {
                ...evt,
                extension: {
                    ...evt.extension,
                    is_selected: true
                },
                prize_date_event: {
                    ...evt.prize_date_event,
                    daily_limits: eventDailyLocal?.length > 0 ? eventDailyLocal : dataDailyEvent || []
                }
            };

            this.prizeCalendarIndex++;
            this.modelTab = TABS().findIndex((item) => item.name === TAB_NAME.page_setting_calendar_lottery);
            this.onHandleCalendarMounted();
        },

        // Handles prize sync emitted by SettingCalendar on init — updates state without switching tabs
        async onCalendarPrizeSync(evt) {
            this.isCalendarDataLoading = true;
            let dataDailyEvent = await this.onGetDailyLimitsPrize(evt);
            this.isCalendarDataLoading = false;
            dataDailyEvent = dataDailyEvent?.map((e) => initInputCalendar(e)) || [];
            let eventDailyLocal = [];
            if (evt.prize_date_event?.daily_limits?.length > 0) {
                eventDailyLocal = evt.prize_date_event.daily_limits.map((e) => {
                    e.id = createIdEventRangeDate({
                        startStr: e.startStr,
                        endStr: e.endStr
                    });
                    return e;
                });
            }

            this.formData.serial_code_prizes = this.formData.serial_code_prizes.map((p) => {
                const isSelected = p.make_id === evt.make_id || (p.id && p.id === evt.id);
                return {
                    ...p,
                    extension: {
                        ...p.extension,
                        is_selected: isSelected
                    }
                };
            });

            this.prizeCalendarInfo = {
                ...evt,
                extension: {
                    ...evt.extension,
                    is_selected: true
                },
                prize_date_event: {
                    ...evt.prize_date_event,
                    daily_limits: eventDailyLocal?.length > 0 ? eventDailyLocal : dataDailyEvent || []
                }
            };

            this.prizeCalendarIndex++;
            // NOTE: Intentionally NOT switching modelTab here to prevent tab jumping on init
        },

        onHandleCalendarMounted() {
            this.$nextTick(() => {
                this.$refs?.settingCalendar[0]?.$refs.CalendarFull.getApi().render();
                this.$refs?.settingCalendar[0]?.onHandleGoToDate();
            });
        },

        onHandleCopy() {
            this.configModalCopyForm.model = true;
        },

        async getMasterCampaign() {
            try {
                let query = 'all/campaigns';
                if (isRolePartner()) {
                    query += `?has[partner]=${getInfoUserLocalStorage().partner_id}`;
                }
                const dataRes = await this.listMaster(query);
                this.listDataMasterCampaign = dataRes;
            } catch (error) {
                console.log('error', error);
            }
        },

        async getMailDetailForm() {
            try {
                const dataGet = await this.getDetailSettingEmail(this.$route.query.id);
                this.inforMailForm = dataGet.data ?? null;
            } catch (error) {
                console.log('error', error);
            }
        },

        onCancelSerialPrize() {
            this.$refs.PrizeSerialCode[0].onHandleCancel();
        },

        onSaveSerialPrize() {
            this.$refs.PrizeSerialCode[0].handleSave();
        },

        onBackStepSerialBlock() {
            this.$refs.PrizeSerialCode[0].handleCancelPrizeBlock();
        },

        onNextStepSerialBlock() {
            this.$refs.PrizeSerialCode[0].onHandleSavePrizeBlock();
        },

        async onHandleGetListSerial() {
            await handleGetListSerial(this);
        }
    },
    async mounted() {
        await this.onGetListAllEmailFrom();
        await this.onGetListAllTemplateMail();
        this.onResetLocalStorage();
        await this.getDetail();
        if (this.$route.query.tab !== undefined) {
            this.modelTab = Number(this.$route.query.tab);
        }
        this.getMasterCampaign();
        this.getMailDetailForm();
    },

    destroyed() {
        this.onResetLocalStorage();
        this.updateBlockList([]);
        this.updateButtonEvent({
            eventEditPage: false,
            eventEditBlock: false,
            eventEditBlockStep2: false,
            eventEditButton: false,
            eventEditPrizeSerialCode: false,
            eventSettingBlockLotterySerial: false,
            eventSettingBlockRejectionSerial: false
        });
    }
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
.tooltip-full-width .tooltip-inner {
    max-width: max-content !important;
    word-break: break-all;
}
</style>
